/*
 * Yurls Shop — productpagina op een telefoon.
 *
 * Drie kleine dingen die alleen zin hebben op een smal scherm, en die de sectie
 * (sections/yurls-product-main.liquid) zelf niet doet:
 *
 *   1. De galerij: swipen tussen de foto's, met bolletjes in plaats van
 *      miniaturen. Het swipen klikt gewoon op de volgende of vorige miniatuur,
 *      dus yurls-gallery.js blijft het enige dat de foto wisselt.
 *   2. "Wat zit erin?": de eerste vier regels, de rest achter "Toon alle".
 *   3. De informatieblokken (gebruik, licentie): uitklapbaar.
 *
 * Het script voegt alleen kenmerken en een paar knoppen toe; wat er op welke
 * schermbreedte zichtbaar is bepaalt assets/yurls-product-mobile.css. Op een
 * breed scherm doet het dus niets zichtbaars, en zonder JavaScript blijft de
 * pagina gewoon volledig staan.
 */
(function () {
  var mq = window.matchMedia('(max-width: 989px)');

  function initGallery(gallery) {
    if (gallery.__yMobile) return;
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-thumb]'));
    var main = gallery.querySelector('.y-pd__main');
    if (thumbs.length < 2 || !main) return;
    gallery.__yMobile = true;

    var card = gallery.closest('.y-pd__gallery');
    if (card) card.classList.add('has-dots');

    var dots = document.createElement('div');
    dots.className = 'y-pd__dots';
    thumbs.forEach(function (thumb, i) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'y-pd__dot';
      dot.setAttribute('aria-label', 'Afbeelding ' + (i + 1));
      dot.addEventListener('click', function () { thumbs[i].click(); });
      dots.appendChild(dot);
    });
    main.parentNode.insertBefore(dots, main.nextSibling);

    function sync() {
      var current = 0;
      thumbs.forEach(function (thumb, i) {
        if (thumb.hasAttribute('data-active')) current = i;
      });
      Array.prototype.forEach.call(dots.children, function (dot, i) {
        dot.setAttribute('aria-current', i === current ? 'true' : 'false');
      });
      return current;
    }

    new MutationObserver(sync).observe(gallery, {
      subtree: true,
      attributes: true,
      attributeFilter: ['data-active']
    });
    sync();

    var startX = null;
    var startY = null;

    main.addEventListener('touchstart', function (event) {
      var touch = event.touches[0];
      startX = touch.clientX;
      startY = touch.clientY;
    }, { passive: true });

    main.addEventListener('touchend', function (event) {
      if (startX === null) return;
      var touch = event.changedTouches[0];
      var dx = touch.clientX - startX;
      var dy = touch.clientY - startY;
      startX = null;
      // Alleen een duidelijke zijwaartse veeg; omhoog en omlaag scrollt de pagina.
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
      var next = (sync() + (dx < 0 ? 1 : -1) + thumbs.length) % thumbs.length;
      thumbs[next].click();
    }, { passive: true });
  }

  function initToc(toc) {
    var rows = toc.querySelectorAll('.y-pd__toc-row');
    if (rows.length <= 4 || toc.__yToc) return;
    toc.__yToc = true;
    toc.classList.add('is-collapsible');

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'y-pd__toc-more';

    function label() {
      var open = toc.classList.contains('is-open');
      button.textContent = open ? 'Toon minder' : 'Toon alle ' + rows.length + ' onderdelen';
      button.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    button.addEventListener('click', function () {
      toc.classList.toggle('is-open');
      label();
    });
    label();
    toc.appendChild(button);
  }

  function initInfos(infos) {
    if (infos.__yInfo) return;
    infos.__yInfo = true;
    infos.classList.add('is-enhanced');

    infos.querySelectorAll('.y-pd__info').forEach(function (item, i) {
      var title = item.querySelector('.y-pd__info-title');
      var text = item.querySelector('.y-pd__info-text');
      if (!title || !text) return;

      text.id = 'y-pd-info-' + i;
      title.setAttribute('aria-controls', text.id);

      function setOpen(open) {
        item.classList.toggle('is-open', open);
        title.setAttribute('aria-expanded', open ? 'true' : 'false');
      }

      function toggle() { setOpen(!item.classList.contains('is-open')); }

      title.addEventListener('click', toggle);
      title.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          toggle();
        }
      });
      setOpen(false);
    });
  }

  // Op een breed scherm zijn de titels geen knoppen, dus zeggen we dat ook niet.
  function roles() {
    document.querySelectorAll('.y-pd__info-title[aria-controls]').forEach(function (title) {
      if (mq.matches) {
        title.setAttribute('role', 'button');
        title.setAttribute('tabindex', '0');
      } else {
        title.removeAttribute('role');
        title.removeAttribute('tabindex');
        title.removeAttribute('aria-expanded');
      }
    });
  }

  function init() {
    document.querySelectorAll('.y-pd__gallery yurls-gallery').forEach(initGallery);
    document.querySelectorAll('.y-pd__toc').forEach(initToc);
    document.querySelectorAll('.y-pd__infos').forEach(initInfos);
    roles();
  }

  if (mq.addEventListener) mq.addEventListener('change', roles);
  else if (mq.addListener) mq.addListener(roles);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
